import { Component, HostListener, OnInit, Input } from '@angular/core';
import { StudentService } from './services/student.service';
import { Student } from './models/student';
import { findLast } from '@angular/compiler/src/directive_resolver';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfigService } from './services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  

  constructor(
    public studentService: StudentService,
    public configService: ConfigService
  ) {}
  

  ngOnInit() {
   
  }
  create(student: Student) {
   
  }

  save() {
    // this.studentModel = {
    //   name: '',
    //   lastname: '',
    //   birthday: new Date(),
    //   done: true,
    //   createDate: new Date(),
    //   lastModifieldDate: new Date(),
    // };
    // this.create(this.studentModel);
   
  }
}
